<script lang="ts" setup>
import StaleDebtorPrices from "@/data-views/tables/pricelist/StaleDebtorPrices.vue";
import { loader } from "@/components/loader/loader";

definePage({
  meta: {
    action: "read",
    subject: "PriceConfiguration",
    navActiveLink: "pricelist-stale-debtor-prices",
  },
});

const loading = ref(false);

onMounted(() => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    loader.stop();
  }, 500);
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <StaleDebtorPrices v-if="!loading" />
      <div v-else style="min-height: 50vh" />
    </VCol>
  </VRow>
</template>

